import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";

/** Text-based Tech Shiksha logo with a minimal outline tech mark. */
export function Logo({ dark = false, testId = NAV.logo }) {
  return (
    <Link
      to="/"
      data-testid={testId}
      className="group inline-flex items-center gap-2.5"
      aria-label="Tech Siksha home"
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-gradient-to-br from-brand to-cyan-accent opacity-90" />
        <img
          src="/logo.jpg"
          alt="Tech Siksha"
          width="36"
          height="36"
          loading="eager"
          className="relative h-9 w-9 rounded-full object-cover ring-2 ring-white"
        />
      </span>
      <span
        className={`font-display text-xl font-extrabold tracking-tight ${
          dark ? "text-white" : "text-white"
        }`}
      >
        Tech<span className="text-brand">&nbsp;Siksha</span>
      </span>
    </Link>
  );
}
